import { authRoles } from '@ameroservices-platform/shipfromstore-backend/app/auth';
import store from '@ameroservices-platform/shipfromstore-backend/app/store';
import { logoutUser } from '@ameroservices-platform/shipfromstore-backend/app/auth/store/userSlice';

const LogoutConfig = {
	auth: authRoles.user,
	routes: [
		{
			path: 'logout',
			element: () => {
				store.dispatch(logoutUser());
				return 'Logging out..';
			},
		},
	],
};

export default LogoutConfig;
